export default function timeSetter(data) {
  const time = data?.slice(11, 16);

  return time;
}
